import { Injectable } from "@angular/core";
import swal from "sweetalert";

@Injectable({ providedIn: "root" })
export class ModalService {
    constructor() {}

    public showModal(message: string, title = "Operation failed"): void {
      swal({
        title: title,
        text: message,
        icon: null,
        buttons: {
          confirm: {
            text: 'Ok',
            value: true,
            visible: true,
            closeModal: true,
            className: "bg-danger"
          }
        }
      });
    }
}
